import {urlParam} from '../default/category_seating_chart'
import { displaySelectedFilter } from './seating_chart_filter_without_svg'

export default {
  showPackages() {
    let pkg_grp = urlParam('package-group')
    if (pkg_grp) {
      displaySelectedFilter($(`.${pkg_grp}`))
    }
  }
}
